export enum GenPaymentTypeEnum {
    CARD = 'CARD',
    ACCOUNT = 'ACCOUNT',
    WELLS_FARGO = 'WELLS_FARGO'
}
